import React from 'react';
import './Profile.css';

const Profile = () => {
  return (
    <div className="profile">
      <img src="https://wallpapers.com/images/hd/fortnite-pfp-psycho-bandit-with-star-wand-np52v6edf5v4hv3w.jpg" alt="Profile" className="profile-img" />
      <h2></h2>
      <p className='raleway-czcionka'>Cześć! Tutaj znajdziesz wszystkie moje linki!</p>
    </div>
  );
};

export default Profile;
